import { JournCalendarsPage } from '_/features/journ/ui/pages/journ-calendars-page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/journ/calendars')({
	staticData: { title: 'journ_calendars_title' },
	component: JournCalendarsPage,
})
